















import {Component, Mixins} from 'vue-property-decorator'
import {MixinQueryRouter} from 'simpli-web-sdk'

@Component
export default class DashboardLayoutView extends Mixins(MixinQueryRouter) {}
